import React from 'react';

import {assert} from 'Asserts';
import {BioentitySearchInputWithItems} from 'inventory/BioentitySearchInput';
import {FilterKey, GenericFilter} from 'search/SearchConstants';
import pick from 'util/pick';
import removeNulls from 'util/removeNulls';

import {BaseFilterFormProps, BASE_FILTER_FORM_PROP_NAMES, FilterStyle} from './base/FilterFormConstants';
import SecondaryFilterFormSkeleton from './base/SecondaryFilterFormSkeleton';

export interface QueryApiBioentityIdFilterFormProps extends BaseFilterFormProps {
  filter: GenericFilter<FilterKey.QUERY_API_BIOENTITY_ID>;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: GenericFilter<FilterKey.QUERY_API_BIOENTITY_ID>) => void;
  onRemove?: () => void;
  schemaId: string;
}

export default function QueryApiBioentityIdFilterForm(
  props: QueryApiBioentityIdFilterFormProps
): JSX.Element {
  assert(
    props.filterStyle === FilterStyle.SECONDARY,
    'ID filter only configured to work as secondary filter'
  );
  const skeletonProps = pick(props, ...BASE_FILTER_FORM_PROP_NAMES);
  const searchInput = (
    <BioentitySearchInputWithItems
      autoFocus={false}
      onChange={(newItems) => {
        props.onChangeFilter({...props.filter, value: removeNulls(newItems.map((item) => item.id ?? null))});
      }}
      selectedItems={props.filter.value.map((id) => ({id}))}
      shouldAllowMultiple={true}
      tagSchemaOrInterfaceId={props.schemaId}
    />
  );

  return (
    <SecondaryFilterFormSkeleton
      {...skeletonProps}
      nodeGrid={[[searchInput]]}
      onChangeFilterKey={props.onChangeFilterKey}
      selectedFilterKey={props.selectedFilterKey}
      onRemove={props.onRemove!}
    />
  );
}
